import React, { useEffect } from "react"

import ItemPickerOld from "./old"
import ItemPickerNew from "./new"
import { IItemPickerField } from "../.."
import { FeatureType } from "../../helper"
import { previewFeaturesAPI } from "../../../../apis"

type Props = IItemPickerField

const ItemPicker: React.FC<Props> = (props: Props) => {
    const [isNewUIShown, setIsNewUIShown] = React.useState(false)

    const checkEnableBetaFeatureFlag = async (): Promise<void> => {
        const enabledBetaFeatures =
            await previewFeaturesAPI.getEnabledPreviewFeatures()
        const newUiFlag = enabledBetaFeatures.previewFeatures.some(
            (featureFlag) => featureFlag.id === FeatureType.NewItemCollections,
        )
        setIsNewUIShown(newUiFlag)
    }

    useEffect(() => {
        checkEnableBetaFeatureFlag()
    }, [])

    return (
        <>
            {isNewUIShown ? (
                <ItemPickerNew {...props} />
            ) : (
                <ItemPickerOld {...props} />
            )}
        </>
    )
}

export default ItemPicker
